module.exports = __webpack_public_path__ + "img/platform-development.0b8a0bbd.webp";